module.exports = __webpack_public_path__ + "static/media/jackpot-inner-background.be16b1ff.jpg";